// styles.ts
import styled from "styled-components";
import { COLORS } from "../../../shared/consts";
import { toRem } from "shared/helpers";

export const WidgetWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${toRem(16)};
  padding: ${toRem(24)};
  height: 100%;
  min-height: 0;
  cursor: pointer;
`;

export const WidgetCalendarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${toRem(16)};

  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: ${COLORS.BORDER.MUTED} transparent;
  &::-webkit-scrollbar {
    width: ${toRem(6)};
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${COLORS.BORDER.MUTED};
    border-radius: ${toRem(6)};
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
`;

export const Divider = styled.div`
  height: 1px;
  background: ${COLORS.BORDER.MUTED};
  flex: 0 0 auto;
`;

export const WidgetTitle = styled.h1`
  color: ${COLORS.FG.DEFAULT};
  font-size: ${toRem(16)};
  font-weight: bold;
  flex: 0 0 auto;
`;
